export type NetGexSign =
  | { kind: "sign"; sign: "+" | "-" | "0" }
  | { kind: "refused"; reason: "NO_ROWS" | "NULL_NET" };

export function netGexSign(rows: { net: number | null }[]): NetGexSign {
  if (rows.length === 0) return { kind: "refused", reason: "NO_ROWS" };
  let total = 0;
  for (const row of rows) {
    if (row.net === null) return { kind: "refused", reason: "NULL_NET" };
    total += row.net;
  }
  return { kind: "sign", sign: total > 0 ? "+" : total < 0 ? "-" : "0" };
}

export function spotVsFlip(
  spot: number | null,
  flip: number | null,
): "ABOVE FLIP" | "BELOW FLIP" | "AT FLIP" | "NO FLIP IN RANGE" | "SPOT UNSERVED" {
  if (spot === null) return "SPOT UNSERVED";
  if (flip === null) return "NO FLIP IN RANGE";
  return spot > flip ? "ABOVE FLIP" : spot < flip ? "BELOW FLIP" : "AT FLIP";
}
